<template>
  <aside class="transform top-0 left-0 w-64 bg-white fixed h-full overflow-auto ease-in-out transition-all duration-300 z-30"
    :class="isOpen ? 'translate-x-0' : '-translate-x-full'">
    <h1>teste</h1>
  </aside>
</template>

<script>
export default {
  data: () => ({
    isOpen: false,
  }),
  watch: {
    // isOpen: {
    //   immediate: true,
    //   handler(isOpen) {
    //     if (process.client) {
    //       if (isOpen) document.body.style.setProperty("overflow", "hidden");
    //       else document.body.style.removeProperty("overflow");
    //     }
    //   }
    // }
  }
}
</script>

<style>

</style>